<div
  class="p-wrapper-custom tablebox"
  *ngIf="
    isQr1YearOverYearDashboardReport === true ||
    isQr2YearOverYearDashboardReport === true ||
    isQr3YearOverYearDashboardReport === true ||
    isQr4YearOverYearDashboardReport === true
  ">
  <div
    class="thead dashboard-table-thead d-flex align-item-center justify-content-between mb-2">
    <h2 class="m-0">Year Over Year As of {{ currentDateAndMonth }}</h2>
    <div class="lds-ring inline me-auto ms-2" *ngIf="showSmallLoader"></div>
  </div>

  <p-table
    id="myTable"
    #dt
    stripedRows
    [scrollable]="true"
    responsiveLayout="scroll"
    [value]="[[]]"
    styleClass="p-datatable-customers customcombinetable"
    [rowHover]="true"
    [autoLayout]="true"
    [resizableColumns]="false">
    <ng-template pTemplate="header">
      <tr>
        <th></th>
        <th class="text-left">Total Sell</th>
        <th class="text-left"></th>
        <th class="text-left">GP $</th>
        <th class="text-left"></th>
        <th class="text-left">GP %</th>
        <th class="text-left">Growth %</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-openClientCreditsDetailLists
      let-rowIndex="rowIndex">
      <tr>
        <td class="text-left">
          {{ yearToYearSummaryDashboardResponseGrid.currentFiscalYear }}
        </td>
        <td class="text-left">
          {{
            yearToYearSummaryDashboardResponseGrid.revenueYear1
              | currency: "USD" : "symbol" : "0.2-2"
          }}
        </td>
        <td class="text-left">
          <i
            class="pi pi-arrow-up fw-bold fs-4 successcol"
            *ngIf="
              (yearToYearSummaryDashboardResponseGrid.revenueYear1 ?? 0) >=
              (yearToYearSummaryDashboardResponseGrid.revenueYear2 ?? 0)
            "></i>
          <i
            class="pi pi-arrow-down fw-bold fs-4 delcol"
            *ngIf="
              (yearToYearSummaryDashboardResponseGrid.revenueYear1 ?? 0) <
              (yearToYearSummaryDashboardResponseGrid.revenueYear2 ?? 0)
            "></i>
          <!-- <img
            *ngIf="
              (yearToYearSummaryDashboardResponseGrid.revenueYear1 ?? 0) >=
              (yearToYearSummaryDashboardResponseGrid.revenueYear2 ?? 0)
            "
            src="../../../../../assets/images/green-arrow.png"
            alt="img"
            width="35"
            height="35" />

          <img
            *ngIf="
              (yearToYearSummaryDashboardResponseGrid.revenueYear1 ?? 0) <
              (yearToYearSummaryDashboardResponseGrid.revenueYear2 ?? 0)
            "
            src="../../../../../assets/images/red-arrow.png"
            alt="img"
            width="45"
            height="45" /> -->
        </td>
        <td class="text-left">
          {{
            yearToYearSummaryDashboardResponseGrid.gpYear1
              | currency: "USD" : "symbol" : "0.2-2"
          }}
        </td>
        <td class="text-left">
          <i
            class="pi pi-arrow-up fw-bold fs-4 successcol"
            *ngIf="
              (yearToYearSummaryDashboardResponseGrid.gpYear1 ?? 0) >=
              (yearToYearSummaryDashboardResponseGrid.gpYear2 ?? 0)
            "></i>
          <i
            class="pi pi-arrow-down fw-bold fs-4 delcol"
            *ngIf="
              (yearToYearSummaryDashboardResponseGrid.gpYear1 ?? 0) <
              (yearToYearSummaryDashboardResponseGrid.gpYear2 ?? 0)
            "></i>
          <!-- <img
            *ngIf="
              (yearToYearSummaryDashboardResponseGrid.gpYear1 ?? 0) >=
              (yearToYearSummaryDashboardResponseGrid.gpYear2 ?? 0)
            "
            src="../../../../../assets/images/green-arrow.png"
            alt="img"
            width="35"
            height="35" />

          <img
            *ngIf="
              (yearToYearSummaryDashboardResponseGrid.gpYear1 ?? 0) <
              (yearToYearSummaryDashboardResponseGrid.gpYear2 ?? 0)
            "
            src="../../../../../assets/images/red-arrow.png"
            alt="img"
            width="45"
            height="45" /> -->
        </td>
        <td class="text-left">
          {{
            yearToYearSummaryDashboardResponseGrid.gpPercentageYear1
              | number: "1.2-2"
          }}
        </td>
        <td class="text-left">
          <span
            *ngIf="
              yearToYearSummaryDashboardResponseGrid &&
              yearToYearSummaryDashboardResponseGrid.growthPercentageYear1 &&
              yearToYearSummaryDashboardResponseGrid.growthPercentageYear1 > 0
            "
            style="
              color: white;
              font-weight: bold;
              background-color: green;
              display: inline-block;
              padding: 0.3rem;
              width: 60px;
            ">
            {{
              yearToYearSummaryDashboardResponseGrid.growthPercentageYear1
                | number: "1.2-2"
            }}
          </span>
          <span
            *ngIf="
              yearToYearSummaryDashboardResponseGrid &&
              yearToYearSummaryDashboardResponseGrid.growthPercentageYear1 &&
              yearToYearSummaryDashboardResponseGrid.growthPercentageYear1 <= 0
            "
            style="
              color: white;
              font-weight: bold;
              background-color: #ec9ebc;
              display: inline-block;
              padding: 0.3rem;
              width: 60px;
            ">
            {{
              yearToYearSummaryDashboardResponseGrid.growthPercentageYear1
                | number: "1.2-2"
            }}
          </span>
        </td>
      </tr>

      <tr>
        <td class="text-left">
          {{ yearToYearSummaryDashboardResponseGrid.currentFiscalYear - 1 }}
        </td>
        <td class="text-left">
          {{
            yearToYearSummaryDashboardResponseGrid.revenueYear2
              | currency: "USD" : "symbol" : "0.2-2"
          }}
        </td>
        <td></td>
        <td class="text-left">
          {{
            yearToYearSummaryDashboardResponseGrid.gpYear2
              | currency: "USD" : "symbol" : "0.2-2"
          }}
        </td>
        <td></td>
        <td class="text-left">
          {{
            yearToYearSummaryDashboardResponseGrid.gpPercentageYear2
              | number: "1.2-2"
          }}
        </td>
        <td class="text-left">
          <span
            *ngIf="
              yearToYearSummaryDashboardResponseGrid &&
              yearToYearSummaryDashboardResponseGrid.growthPercentageYear2 &&
              yearToYearSummaryDashboardResponseGrid.growthPercentageYear2 > 0
            "
            style="
              color: white;
              font-weight: bold;
              background-color: green;
              display: inline-block;
              padding: 0.3rem;
              width: 60px;
            ">
            {{
              yearToYearSummaryDashboardResponseGrid.growthPercentageYear2
                | number: "1.2-2"
            }}
          </span>
          <span
            *ngIf="
              yearToYearSummaryDashboardResponseGrid &&
              yearToYearSummaryDashboardResponseGrid.growthPercentageYear2 &&
              yearToYearSummaryDashboardResponseGrid.growthPercentageYear2 <= 0
            "
            style="
              color: white;
              font-weight: bold;
              background-color: #ec9ebc;
              display: inline-block;
              padding: 0.3rem;
              width: 60px;
            ">
            {{
              yearToYearSummaryDashboardResponseGrid.growthPercentageYear2
                | number: "1.2-2"
            }}
          </span>
        </td>
      </tr>

      <tr>
        <td class="text-left">
          {{ yearToYearSummaryDashboardResponseGrid.currentFiscalYear - 2 }}
        </td>
        <td class="text-left">
          {{
            yearToYearSummaryDashboardResponseGrid.revenueYear3
              | currency: "USD" : "symbol" : "0.2-2"
          }}
        </td>
        <td></td>
        <td class="text-left">
          {{
            yearToYearSummaryDashboardResponseGrid.gpYear3
              | currency: "USD" : "symbol" : "0.2-2"
          }}
        </td>
        <td></td>
        <td class="text-left">
          {{
            yearToYearSummaryDashboardResponseGrid.gpPercentageYear3
              | number: "1.2-2"
          }}
        </td>
        <td class="text-left"></td>
      </tr>
    </ng-template>
  </p-table>

  <div
    class="thead dashboard-table-thead d-flex align-item-center justify-content-between mb-2">
    <h2 class="mb-1 mt-2">
      Tiger Status As of
      {{
        yearToYearSummaryDashboardResponseGrid.currentDate | date: "MM-dd-yyyy"
      }}
    </h2>
    <div class="lds-ring inline me-auto ms-2" *ngIf="showSmallLoader"></div>
  </div>
  <p-table
    #dt
    responsiveLayout="scroll"
    [value]="[[]]"
    styleClass="p-datatable-customers customcombinetable"
    [rowHover]="true"
    [autoLayout]="true"
    [resizableColumns]="false">
    <ng-template pTemplate="header">
      <tr>
        <th class="text-left">$Till Golden</th>
        <th class="text-left">$Till Super</th>
        <th class="text-left">$Till Mega</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-openClientCreditsDetailLists
      let-rowIndex="rowIndex">
      <tr>
        <td class="text-left">
          <div
            *ngIf="
              (yearToYearSummaryDashboardResponseGrid.gpYear1 ?? 0) >
                (yearToYearSummaryDashboardResponseGrid
                  ?.getYearToYearSummaryTigerDetailsResponse?.goldenTigerFrom ??
                  0);
              then showgoldentiger;
              else showgoldentigervalue
            ">
            here is ignored
          </div>
          <ng-template #showgoldentiger>
            <img
              src="../../../../../assets/images/running-tiger.gif"
              class="instruction-image"
              width="50px;"
              alt="img" />
          </ng-template>
          <ng-template #showgoldentigervalue>{{
            setTigerTargetValue(
              yearToYearSummaryDashboardResponseGrid
                ?.getYearToYearSummaryTigerDetailsResponse?.goldenTigerFrom ??
                0,
              yearToYearSummaryDashboardResponseGrid
                ?.getYearToYearSummaryTigerDetailsResponse?.goldenTigerTo ?? 0
            ) | currency: "USD" : "symbol" : "0.2-2"
          }}</ng-template>
        </td>
        <td class="text-left">
          <div
            *ngIf="
              (yearToYearSummaryDashboardResponseGrid?.gpYear1 ?? 0) >
                (yearToYearSummaryDashboardResponseGrid
                  ?.getYearToYearSummaryTigerDetailsResponse?.superTigerFrom ??
                  0);
              then showsupertiger;
              else showsupertigervalue
            "></div>

          <ng-template #showsupertiger>
            <img
              src="../../../../../assets/images/running-tiger.gif"
              class="instruction-image"
              width="50px;"
              alt="img" /><br />
            <img
              src="../../../../../assets/images/running-tiger.gif"
              class="instruction-image"
              width="50px;"
              alt="img" />
          </ng-template>

          <ng-template #showsupertigervalue>{{
            setTigerTargetValue(
              yearToYearSummaryDashboardResponseGrid
                ?.getYearToYearSummaryTigerDetailsResponse?.superTigerFrom ?? 0,
              yearToYearSummaryDashboardResponseGrid
                ?.getYearToYearSummaryTigerDetailsResponse?.superTigerTo ?? 0
            ) | currency: "USD" : "symbol" : "0.2-2"
          }}</ng-template>
        </td>
        <td class="text-left">
          <div
            *ngIf="
              (yearToYearSummaryDashboardResponseGrid?.gpYear1 ?? 0) >
                (yearToYearSummaryDashboardResponseGrid
                  ?.getYearToYearSummaryTigerDetailsResponse?.megaTigerFrom ??
                  0);
              then showmegatiger;
              else showsmegatigervalue
            "></div>
          <ng-template #showmegatiger>
            <img
              *
              src="../../../../../assets/images/running-tiger.gif"
              class="instruction-image"
              width="50px;"
              alt="img" />
            <img
              src="../../../../../assets/images/running-tiger.gif"
              class="instruction-image"
              width="50px;"
              alt="img" /><br />
            <img
              src="../../../../../assets/images/running-tiger.gif"
              class="instruction-image"
              width="50px;"
              alt="img" />
            <img
              src="../../../../../assets/images/running-tiger.gif"
              class="instruction-image"
              width="50px;"
              alt="img" />
          </ng-template>
          <ng-template #showsmegatigervalue>{{
            setTigerTargetValue(
              yearToYearSummaryDashboardResponseGrid
                ?.getYearToYearSummaryTigerDetailsResponse?.megaTigerFrom ?? 0,
              yearToYearSummaryDashboardResponseGrid
                ?.getYearToYearSummaryTigerDetailsResponse?.megaTigerTo ?? 0
            ) | currency: "USD" : "symbol" : "0.2-2"
          }}</ng-template>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<div
  class="p-wrapper-custom tablebox"
  *ngIf="
    isQr1YearOverYearDashboardReport === false &&
    isQr2YearOverYearDashboardReport === false &&
    isQr3YearOverYearDashboardReport === false &&
    isQr4YearOverYearDashboardReport === false
  ">
  <div
    class="thead dashboard-table-thead d-flex align-item-center justify-content-between mb-2">
    <h1 class="m-0">{{ heading }}</h1>
    <div class="lds-ring inline me-auto ms-2" *ngIf="showSmallLoader">
      <div></div>
      <div></div>
      <div></div>
    </div>
    <a class="text-decoration-none" (click)="onViewCompleteList()">{{
      viewCompleteListHeading()
    }}</a>
  </div>

  <p-table
    #dt
    stripedRows
    [scrollable]="true"
    responsiveLayout="scroll"
    [value]="data1"
    [rowHover]="true"
    [rows]="20"
    [size]="'small'"
    [scrollable]="true"
    scrollHeight="calc(100vh - 66vh)"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 20, 50, 1000]"
    [paginator]="data1.length >= 20"
    [autoLayout]="true"
    [resizableColumns]="true">
    <ng-template pTemplate="header">
      <tr>
        <th
          [ngClass]="[
            col.field === 'note' ? 'text-left' : 'text-left',
            col.isLongValueTrimmed ? 'trimmedby30char' : '',
          ]"
          *ngFor="let col of columns"
          [innerHTML]="col.header"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
      <tr>
        <td
          *ngFor="let col of columns"
          [ngClass]="[
            col.isLongValueTrimmed ? 'trimmeddescription trimmedby30char' : '',
            col.isNumber || col.field === 'openAmountUSD' ? 'text-right' : '',
          ]">
          <!-- Column with percentage symbol -->
          <ng-container *ngIf="col.isPercentageSymbol && !col.link">
            {{
              rowData[col.field]
                | hidevalueifzero
                | number: "1.2-2"
                | percentagesymbol
            }}
          </ng-container>

          <ng-container *ngIf="col.isPercentageSymbol && col.link">
            <a
              class="link text-decoration-none"
              (click)="
                redirect(
                  rowData[col.linkField],
                  col.field,
                  rowData,
                  col.linkField
                )
              "
              *ngIf="col.link"
              ><ng-container>{{
                rowData[col.field]
                  | hidevalueifzero
                  | number: "1.2-2"
                  | percentagesymbol
              }}</ng-container></a
            >
          </ng-container>
          <!-- end of Column with percentage symbol -->

          <!-- Column is numeric and Should show the Currency symbol -->
          <ng-container
            *ngIf="
              !col.isPercentageSymbol &&
              col.isNumber &&
              col.isCurrencySymbol &&
              (rowData[col.field] | typeof) === 'number' &&
              !col.link
            ">
            {{
              rowData[col.field]
                | hidevalueifzero
                | currency: "USD" : "symbol" : "1.2-2"
            }}
          </ng-container>

          <ng-container
            *ngIf="
              !col.isPercentageSymbol &&
              col.isNumber &&
              col.isCurrencySymbol &&
              (rowData[col.field] | typeof) === 'number' &&
              col.link
            ">
            <a
              class="link text-decoration-none"
              (click)="
                redirect(
                  rowData[col.linkField],
                  col.field,
                  rowData,
                  col.linkField
                )
              "
              *ngIf="col.link"
              ><ng-container>{{
                rowData[col.field]
                  | hidevalueifzero
                  | currency: "USD" : "symbol" : "1.2-2"
              }}</ng-container></a
            >
          </ng-container>
          <!-- end of column is numeric and should show the Currency Symbol -->

          <ng-container
            *ngIf="
              !col.isPercentageSymbol &&
              col.isNumber &&
              !col.isCurrencySymbol &&
              (rowData[col.field] | typeof) === 'number' &&
              !col.link
            ">
            {{ rowData[col.field] | number: "1.2-2" }}
          </ng-container>
          <ng-container
            *ngIf="
              !col.isPercentageSymbol &&
              col.isNumber &&
              !col.isCurrencySymbol &&
              (rowData[col.field] | typeof) === 'number' &&
              col.link
            ">
            <a
              class="link text-decoration-none"
              (click)="
                redirect(
                  rowData[col.linkField],
                  col.field,
                  rowData,
                  col.linkField
                )
              "
              *ngIf="col.link"
              ><ng-container>{{
                rowData[col.field] | number: "1.2-2"
              }}</ng-container></a
            >
          </ng-container>
          <ng-container *ngIf="col.isDate">
            <span *ngIf="rowData[col.field] | hidedynamicsdate">
              {{ rowData[col.field] | date: "MM-dd-yyyy" }}
            </span>
          </ng-container>
          <ng-container *ngIf="!(col.isNumber || col.isDate)">
            <a
              class="link text-decoration-none"
              (click)="
                redirect(
                  rowData[col.linkField],
                  col.field,
                  rowData,
                  col.linkField
                )
              "
              *ngIf="col.link"
              ><ng-container>{{ rowData[col.field] }}</ng-container></a
            >
            <ng-container *ngIf="!col.link && col.field === 'openAmountUSD'">{{
              rowData[col.field] | currency: "USD" : "symbol" : "0.2-2"
            }}</ng-container>

            <ng-container *ngIf="!col.link && col.field !== 'openAmountUSD'">{{
              rowData[col.field]
            }}</ng-container>
          </ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="30">No Data Found.</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="footer">
      <!-- <tr *ngIf="displayFooter">
        <td colspan="2" class="text-right">Totals</td>
        <td>{{ merchTotal | currency: 'USD' }}</td>
        <td>{{ freightTotal | currency: 'USD' }}</td>
        <td>{{ taxTotal | currency: 'USD' }}</td>
        <td>{{ invTotalSum | currency: 'USD' }}</td>
        <td colspan="2" class="text-right"></td>
      </tr> -->
      <tr
        *ngIf="dasbhoardReportState === DashboardReport.OrdersWrittenthismonth">
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td class="align-left">
          {{ qR2Reports.totalVolume | number: "1.2-2" }}
        </td>
        <td class="align-left">
          {{ qR2Reports.totalNetComm | number: "1.2-2" }}
        </td>
        <td class="align-left">
          {{ qR2Reports.totalNetGpPercentage | number: "1.2-2" }}
        </td>
      </tr>

      <tr
        *ngIf="
          dasbhoardReportState === DashboardReport.InvoicesPostedthismonth
        ">
        <td colspan="2"></td>
        <ng-container *ngIf="qr3Response">
          <td class="align-left">
            {{ qr3Response.merchTotal | number: "1.2-2" }}
          </td>
          <td class="align-left">
            {{ qr3Response.freightTotal | number: "1.2-2" }}
          </td>
          <td class="align-left">
            {{ qr3Response.taxTotal | number: "1.2-2" }}
          </td>
          <td class="align-left">
            {{ qr3Response.invTotalSum | number: "1.2-2" }}
          </td>
          <td colspan="3" class="text-end"></td>
        </ng-container>
      </tr>

      <tr *ngIf="dasbhoardReportState === 'AR Aging Dashboard Report'">
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td class="text-right">
          {{ totalOutstanding | currency: "USD" : "symbol" : "0.2-2" }}
        </td>
        <td></td>
        <td></td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!--commeneted for Structure changes-->
<!-- <jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="orderDisplayModal"
  [displayModal]="orderDisplayModal"
  (closeEvent)="closeModalForSaleOrder()">
  <h1 class="panelHeading">Order Summary</h1>
  <div class="panelBody">
    <jni-order-summary
      [isModal]="true"
      [saleOrderIdFromModal]="saleOrderId"
      (scrollHiddenStatus)="scrollHiddenStatus()"
      (closeOrderSummaryModalEvent)="closeModalForSaleOrder()"></jni-order-summary>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="clientDisplayModal"
  [displayModal]="clientDisplayModal"
  (closeEvent)="closeModalForClient()">
  <h1 class="panelHeading">Client Summary</h1>
  <div class="panelBody">
    <jni-client-details
      [clientIdFromModal]="clientId"
      (scrollHiddenStatus)="scrollHiddenStatus()"
      (closeEvent)="closeModalForClient()"
      [isModal]="true">
    </jni-client-details>
  </div>
</jni-modal-stacker> -->

<!-- <jni-modal-stacker
  *ngIf="samplePODisplayModal"
  [displayModal]="samplePODisplayModal"
  (closeEvent)="closeModalForSamplePO()"
>
  <h1 class="panelHeading">SamplePO Listing</h1>
  <div class="panelBody">
    <jni-samplepo-listing
      [ponumber]="ponumber"
      (scrollHiddenStatus)="scrollHiddenStatus()"
    >
    </jni-samplepo-listing>
  </div>
</jni-modal-stacker> -->

<!-- <jni-modal-stacker
  *ngIf="qr1DisplayModal"
  [displayModal]="qr1DisplayModal"
  (closeEvent)="closeModalForqr1()">
  <h1 class="panelHeading">Chargeback Aging Report Listing</h1>
  <div class="panelBody">
    <jni-qr1-complete
      (scrollHiddenStatus)="scrollHiddenStatus()"></jni-qr1-complete>
  </div>
</jni-modal-stacker> -->

<!-- <jni-modal-stacker
  *ngIf="qr2DisplayModal"
  [displayModal]="qr2DisplayModal"
  (closeEvent)="closeModalForqr2()">
  <h1 class="panelHeading">Orders Written this month Listing</h1>
  <div class="panelBody">
    <jni-qr2-complete
      (scrollHiddenStatus)="scrollHiddenStatus()"></jni-qr2-complete>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="qr3DisplayModal"
  [displayModal]="qr3DisplayModal"
  (closeEvent)="closeModalForqr3()">
  <h1 class="panelHeading">Invoices Posted this month Listing</h1>
  <div class="panelBody">
    <jni-qr3-complete (scrollHiddenStatus)="scrollHiddenStatus()">
    </jni-qr3-complete>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="qr4DisplayModal"
  [displayModal]="qr4DisplayModal"
  (closeEvent)="closeModalForqr4()">
  <h1 class="panelHeading">Open orders by In Hands Date Listing</h1>
  <div class="panelBody">
    <jni-qr4-complete
      (scrollHiddenStatus)="scrollHiddenStatus()"></jni-qr4-complete>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="qr6DisplayModal"
  [displayModal]="qr6DisplayModal"
  (closeEvent)="closeModalForqr6()">
  <h1 class="panelHeading">Ready To Bill Report</h1>

  <div class="panelBody">
    <jni-ready-to-bill [isFromStacker]="true"></jni-ready-to-bill>
  </div>
</jni-modal-stacker>
<jni-modal-stacker
  *ngIf="qr5DisplayModal"
  [displayModal]="qr5DisplayModal"
  (closeEvent)="closeModalForqr5()">
  <h1 class="panelHeading">AR Aging Dashboard Report</h1>

  <div class="panelBody">
    <jni-ar-aging-details-report
      (scrollHiddenStatus)="scrollHiddenStatus()"></jni-ar-aging-details-report>
  </div>
</jni-modal-stacker> -->

<!-- <jni-modal-stacker
  *ngIf="invoiceReviewSummaryDisplayModal"
  [displayModal]="invoiceReviewSummaryDisplayModal"
  (closeEvent)="closeModalForInvoiceReview()"
>
  <h1 class="panelHeading d-flex">Invoice Review</h1>
  <div class="panelBody">
    <jni-invoice-review-summary
      [saleOrderId]="saleOrderId"
      [projId]="projId"
    ></jni-invoice-review-summary>
  </div>
</jni-modal-stacker> -->
